// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-wrapper {
  position: relative;
  margin-right: 6px; }
  .dropdown-wrapper .dropdown-btn {
    display: flex;
    align-items: center;
    color: #586f80;
    outline: none;
    border-radius: 50px;
    line-height: 20px; }
    .dropdown-wrapper .dropdown-btn span {
      display: flex; }
    .dropdown-wrapper .dropdown-btn:focus, .dropdown-wrapper .dropdown-btn:hover {
      color: #586f80;
      border: 1px solid #586f80; }
  .dropdown-wrapper .active {
    background-color: #586f80;
    color: #fff; }
    .dropdown-wrapper .active:hover {
      background-color: #586f58;
      color: #fff; }
  .dropdown-wrapper .checkbox-wrapper {
    position: absolute;
    z-index: 1;
    background: #fff;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.2);
    width: 160px;
    max-height: 500px;
    overflow-y: scroll; }
    .dropdown-wrapper .checkbox-wrapper .ant-checkbox-group {
      display: flex;
      flex-direction: column;
      padding: 24px 8px 0 24px; }
      .dropdown-wrapper .checkbox-wrapper .ant-checkbox-group .ant-checkbox-group-item {
        margin: 0;
        padding-bottom: 24px; }
        .dropdown-wrapper .checkbox-wrapper .ant-checkbox-group .ant-checkbox-group-item span {
          color: #0a0a14; }
    .dropdown-wrapper .checkbox-wrapper .clear-btn-wrapper {
      display: flex;
      justify-content: space-between; }
      .dropdown-wrapper .checkbox-wrapper .clear-btn-wrapper .clear-btn {
        background-color: #fff;
        border: none;
        padding: 8px 12px;
        color: #767676;
        letter-spacing: 0.8px;
        cursor: pointer; }
        .dropdown-wrapper .checkbox-wrapper .clear-btn-wrapper .clear-btn:hover {
          color: #586f80; }
  .dropdown-wrapper .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #586f80;
    border-color: #586f58; }
  .dropdown-wrapper .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .dropdown-wrapper .ant-checkbox:hover .ant-checkbox-inner,
  .dropdown-wrapper .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #586f58; }
  .dropdown-wrapper li {
    list-style: none; }
`, "",{"version":3,"sources":["webpack://./src/components/Dropdown/dropdown.scss"],"names":[],"mappings":"AAAA;EACI,kBAAkB;EAClB,iBAAiB,EAAA;EAFrB;IAKQ,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,iBAAiB,EAAA;IAVzB;MAaY,aAAa,EAAA;IAbzB;MAkBY,cAAc;MACd,yBAAyB,EAAA;EAnBrC;IAwBQ,yBAAyB;IACzB,WAAW,EAAA;IAzBnB;MA4BY,yBAAyB;MACzB,WAAW,EAAA;EA7BvB;IAkCQ,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,2CAA2C;IAC3C,YAAY;IACZ,iBAAiB;IACjB,kBAAkB,EAAA;IAxC1B;MA2CY,aAAa;MACb,sBAAsB;MACtB,wBAAwB,EAAA;MA7CpC;QAgDgB,SAAS;QACT,oBAAoB,EAAA;QAjDpC;UAoDoB,cAAc,EAAA;IApDlC;MA0DY,aAAa;MACb,8BAA8B,EAAA;MA3D1C;QA8DgB,sBAAsB;QACtB,YAAY;QACZ,iBAAiB;QACjB,cAAc;QACd,qBAAqB;QACrB,eAAe,EAAA;QAnE/B;UAsEoB,cAAc,EAAA;EAtElC;IA6EQ,yBAAyB;IACzB,qBAAqB,EAAA;EA9E7B;;;IAoFQ,qBAAqB,EAAA;EApF7B;IAwFQ,gBAAgB,EAAA","sourcesContent":[".dropdown-wrapper {\n    position: relative;\n    margin-right: 6px;\n\n    .dropdown-btn {\n        display: flex;\n        align-items: center;\n        color: #586f80;\n        outline: none;\n        border-radius: 50px;\n        line-height: 20px;\n\n        span {\n            display: flex;\n        }\n\n        &:focus,\n        &:hover {\n            color: #586f80;\n            border: 1px solid #586f80;\n        }\n    }\n\n    .active {\n        background-color: #586f80;\n        color: #fff;\n\n        &:hover {\n            background-color: #586f58;\n            color: #fff;\n        }\n    }\n\n    .checkbox-wrapper {\n        position: absolute;\n        z-index: 1;\n        background: #fff;\n        box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.2);\n        width: 160px;\n        max-height: 500px;\n        overflow-y: scroll;\n\n        .ant-checkbox-group {\n            display: flex;\n            flex-direction: column;\n            padding: 24px 8px 0 24px;\n\n            .ant-checkbox-group-item {\n                margin: 0;\n                padding-bottom: 24px;\n\n                span {\n                    color: #0a0a14;\n                }\n            }\n        }\n\n        .clear-btn-wrapper {\n            display: flex;\n            justify-content: space-between;\n\n            .clear-btn {\n                background-color: #fff;\n                border: none;\n                padding: 8px 12px;\n                color: #767676;\n                letter-spacing: 0.8px;\n                cursor: pointer;\n\n                &:hover {\n                    color: #586f80;\n                }\n            }\n        }\n    }\n\n    .ant-checkbox-checked .ant-checkbox-inner {\n        background-color: #586f80;\n        border-color: #586f58;\n    }\n\n    .ant-checkbox-wrapper:hover .ant-checkbox-inner,\n    .ant-checkbox:hover .ant-checkbox-inner,\n    .ant-checkbox-input:focus + .ant-checkbox-inner {\n        border-color: #586f58;\n    }\n\n    li {\n        list-style: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
